module.exports = {
  BasicText: {
    box_style: "Box style",
    classname: "Class names",
    padding: "Padding",
    PluginName: "Rich Text",
    background_color: "Background color",
    border_color: "Border color",
    border_size: "Border Size",
    border_style: "Border Style",
    opacity: "Opacity",
    radius: "Radius",
    source: "Source",
    font_family: "Font",
    font_size: "Font size",
    text_color: "Text color",
    highlight_color: "Highlight color",
    bold: "Bold",
    italic: "Italic",
    underline: "Underline",
  },
};
